export const formatPromptVersionName = (name) => {
    return name?.length > 5 ? name?.slice(0, 5) : name;
};
